import React, { useRef, useState } from "react";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import config from "../config";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import { getBase64 } from "../helpers/common";

const EditPart = ({ imageBroken, part, onConfirm, image, setImage }) => {
  const [edit, setEdit] = useState(false);
  const [partName, setPartName] = useState("");
  const [partCode, setPartCode] = useState("");
  const [error, setError] = useState({
    partName: false,
    partCode: false,
  });

  if (image) {
    console.log(image);
  }
  // const [image, setImage] = useState({
  //   base: null,
  //   file: null,
  // });
  const inputRefs = useRef([]);

  const clearError = () => {
    setError({
      partName: false,
      partCode: false,
      reviseNo: false,
    });
  };

  const handleOnChangePartName = (e) => {
    const value = e.target.value;
    console.log(value, typeof value);
    setError((prev) => ({
      ...prev,
      partName: false,
    }));
    setPartName(value);
  };

  const handleOnChangePartCode = (e) => {
    const value = e.target.value;
    console.log(value, typeof value);
    setError((prev) => ({
      ...prev,
      partCode: false,
    }));
    setPartCode(value);
  };

  const handleOnCancelEdit = () => {
    clearImage();
    handleOnClose();
  };

  // const clearImage = () => {
  //   setImage({
  //     base: null,
  //     file: null,
  //   });
  // };

  // const clearImage = () => {
  //   setImage([]);
  // };

  const clearImage = (index) => {
    setImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleOnClose = () => {
    setEdit(false);
    clearError();
  };

  const handleOnConfirm = () => {
    try {
      validPart();
      if (onConfirm) {
        onConfirm({
          partName,
          partCode,
          image,
        });
        handleOnClose();
      }
    } catch (error) {
      console.error("handleOnConfirm", error);
    }
  };

  const validPart = () => {
    if (partName === "") {
      setError((prev) => ({
        ...prev,
        partName: true,
      }));
      throw Error("required Part name");
    }
    if (partCode === "") {
      setError((prev) => ({
        ...prev,
        partCode: true,
      }));
      throw Error("required Part code");
    }
  };

  const handleOnChangeImage = async (e, index = null) => {
    console.log(index);
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const base64Img = await getBase64(files[0]);
    setImage((prevImage) => {
      const newArrayImg = [...prevImage];
      if (index !== null) {
        newArrayImg[index] = { base: base64Img, file: files };
      } else {
        newArrayImg.push({ base: base64Img, file: files });
      }
      console.log(newArrayImg);
      return newArrayImg;
    });
  };

  // const handleAddFile = async (e) => {
  //   const files = Array.from(e.target.files);
  //   const base64Img = await getBase64(files[0]);
  //   setImage((prevImage) => [...prevImage, { base: base64Img, file: files }]);
  // };

  const handleAddFile = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const base64Img = await getBase64(files[0]);
    setImage((prevImages) => [...prevImages, { base: base64Img, file: files }]);
  };

  const renderImage = (index) => {
    const img = image[index];
    if (typeof img === "object" && img.base) {
      return img.base;
    }
    return img;
  };
  useEffect(() => {
    if (part?.image?.length > 0) {
      // console.log(part?.image.length);
      const newUrls = part.image.map((e) => {
        console.log(e.url);
        return e.url;
      });
      // setPartImage((prevURL) => [...prevURL, ...newUrls]);
      setImage(newUrls);
    }
  }, [part?.image]);

  useEffect(() => {
    if (edit) {
      return;
    }
    setPartName(part?.part_name);
    setPartCode(part?.part_code);
  }, [part, edit]);

  useEffect(() => {
    console.log(image);
  }, [setImage]);
  return (
    <div className={``}>
      <div className={`flex justify-end`}>
        {edit ? (
          <div className={`flex gap-2`}>
            {/* <div
              className="flex   items-center cursor-pointer bg-colorMain hover:bg-green-500 text-white rounded-full p-2"
              onClick={() => inputRef.current.click()}
            >
              <Add />
              <input
                ref={inputRef}
                type="file"
                hidden
                onChange={handleAddFile}
              />
            </div> */}

            <Button
              // className="bg-orangeCustom "
              variant="outlined"
              onClick={handleOnCancelEdit}
            >
              Cancel
            </Button>
            <Button
              className="bg-colorMain hover:bg-orangeCustom"
              variant="contained"
              onClick={handleOnConfirm}
            >
              Confirm
            </Button>
          </div>
        ) : (
          <div>
            <Button
              variant="outlined"
              onClick={() => setEdit(true)}
              endIcon={<Edit />}
            >
              Edit part
            </Button>
          </div>
        )}
      </div>
      <div
        className={`w-80 drop-shadow rounded-lg overflow-hidden mt-4 relative`}
      >
        {imageBroken ? (
          <NoPhotographyIcon
            sx={{
              width: "14rem",
              height: "14rem",
              color: "#c9c9c9",
            }}
          />
        ) : (
          image.map((url, index) => (
            <div key={index} className="relative image-container">
              {/* <img className="mt-3" key={index} src={url} alt="" /> */}
              <img src={`${renderImage(index)}`} className="mt-2" alt="" />
              {/* {edit && (
                <div
                  className="text-red-400 hover:text-white hover:bg-red-400 hover:bg-opacity-80 cursor-pointer rounded-full p-2 absolute top-0 right-0 m-2"
                  onClick={() => clearImage(index)}
                >
                  <Delete />
                </div>
              )} */}
              {/* {edit && (
                <div
                  className="bg-red-500 hover:bg-opacity-30 rounded-full p-2 cursor-pointer absolute top-0  m-2"
                  onClick={() => inputRefs.current[index].click()}
                >
                  <Edit />
                  <input
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="file"
                    hidden
                    onChange={(e) => handleOnChangeImage(e, index)}
                  />
                </div>
              )} */}
            </div>
          ))
        )}
      </div>
      {edit ? (
        <div>
          <TextField
            label={`Part name`}
            defaultValue={part?.part_name}
            fullWidth
            className={`mt-4`}
            size="small"
            onChange={handleOnChangePartName}
            error={error.partName}
          />
        </div>
      ) : (
        <div className={`flex gap-2 items-center mt-4 justify-between`}>
          <div className={`text-gray-500 font-light`}>Part name</div>
          <div className={`text-black text-opacity-80`}>
            {`${part?.part_name || ""}`}
          </div>
        </div>
      )}
      {edit ? (
        <div>
          <TextField
            label={`Part code`}
            defaultValue={part?.part_code}
            className={`mt-4`}
            fullWidth
            size="small"
            onChange={handleOnChangePartCode}
            error={error.partCode}
          />
        </div>
      ) : (
        <div className={`flex gap-2 items-center mt-2 justify-between`}>
          <div className={`text-gray-500 font-light`}>Part code</div>
          <div className={`text-black text-opacity-80`}>
            {`${part?.part_code || ""}`}
          </div>
        </div>
      )}
      {edit ? (
        <div className={`mt-4  pointer-events-none`}>
          <TextField
            label={`Revise time`}
            defaultValue={part?.revise_time}
            size="small"
            disabled
            fullWidth
            className={``}
            sx={{
              ".Mui-disabled": {
                WebkitTextFillColor: "rgba(0, 0, 0, 0.8)",
              },
            }}
            inputProps={{
              className: `text-black`,
              style: {
                color: "black",
                ":dsiabled": {
                  color: "black",
                },
              },
            }}
          />
        </div>
      ) : (
        <div className={`flex gap-2 items-center mt-2 justify-between`}>
          <div className={`text-gray-500 font-light`}>Revise time</div>
          <div className={`text-black text-opacity-80`}>
            {`${part?.revise_time}`}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditPart;
